import * as d3 from "d3";
import {
    colonAnnotation, contextMenu, createTooltip,
    fw_progressive_1way, generateDownloadData,
    make_x_gridlines,
    make_y_gridlines,
    numberFormat,
} from '../functions'

export default function (chart, divId, vizName,resData, filterParam, checkbox, gridflag) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    var metric1ColorScale = d3.scaleOrdinal().range(fw_progressive_1way)

    var x1Scale = d3.scaleBand().rangeRound([0, chart.width]).padding(0.1)

    var x2Scale = d3.scaleBand().rangeRound([0, chart.width]).padding(0.1)
    var bottom1 = 17
    var top1 = 10

    // Scales. Note the inverted domain fo y-scale: bigger is up!
    var y1Scale = d3.scaleLinear().range([chart.height, 0]);

    var x1AxisLabel = d3.axisBottom(x1Scale)
        .tickSizeInner(-chart.height)
        .tickSizeOuter(-chart.height)

    var x2AxisLabel = d3.axisTop(x2Scale)

    var y1AxisLabel = d3.axisLeft(y1Scale)
        .tickSizeInner(-chart.width)
        .tickSizeOuter(-chart.width)
        .tickFormat(numberFormat)
        .ticks(4)
    // d3.select(".d3-tipmpc" + divId.id).remove(); // clear tooltip based on class of tip element
    // var y1tip = tooltip_class()
    //
    // y1tip.attr('class', 'd3-tipmpc' + divId.id)
    //     .offset([-10, 0])
    //     .html((d) => {
    //         return d.dim1_name + colonAnnotation + numberFormat(d.metric1);
    //     })



    // json loaded asynchronously
    // axios.post(url, filterParam).then(res => {
        let data = resData

        // Data is nested by country
        var categories = d3.nest()
            .key(function (d) {
                return d.dim1_name;
            })
            .entries(data);

        if (checkbox === true) {
            categories.forEach(function (d) {
                d.maxNumber = d3.max(d.values, function (d) {
                    return d.metric1;
                });
            });

            // Compute the minimum and maximum year and percent across symbols.
            x1Scale.domain(data.map(function (d) {
                return d.dim2_name;
            }));

            x2Scale.domain(data.map(function (d) {
                return d.dim2_name;
            }));

            var div = d3.select(divId)
            div.selectAll("*").remove();
            // Add an SVG element for each country, with the desired dimensions and margin.
            div = d3.select(divId).selectAll("svg")
                .data(categories)
                .enter()
                .append("div")

            div.append("svg")
                .attr("width", chart.width + chart.margin.left + chart.margin.right)
                .attr("height", function (d, i) {
                    return categories[i] === categories[categories.length - 1] ?
                        chart.height + top1 + chart.margin.bottom : categories[i] === categories[0] ? chart.height + chart.margin.top + bottom1 : chart.height + top1 + bottom1
                })
                .append("g")
                .attr("transform", function (d, i) {
                    return categories[i] == categories[0] ?
                        "translate(" + chart.margin.left + "," + chart.margin.top + ")" : "translate(" + chart.margin.left + "," + top1 + ")"
                })

                .attr("id", (d) => {
                    return d.key
                })

            const tooltip = createTooltip(divId);

            categories.forEach(function (d) {
                //CSS.escape(id) - will escape special character in id/key

                var div = d3.select("#" + CSS.escape(d.key));
                y1Scale.domain([0, d.maxNumber]);

                div.append("g")
                    .attr("class", "x axis")
                    .attr('class', 'x axis-grid')
                    .attr("transform", "translate(0," + chart.height + ")")
                    .call(x1AxisLabel)
                    // .style('fill', fontColor)
                    //addidng text on x-axis
                    .style('display', function (d, i) {
                        return categories[i] == categories[categories.length - 1] ? "block " : "none"
                    })
                    .selectAll('text')
                    // .style("font-size", axisLabelFontSize)
                    .style('text-anchor', 'end')
                    .attr('dx', '-.1em')
                    .attr('transform', 'rotate(-50)');


                //adding axis labels
                div.append("text")
                    .attr("transform",
                        "translate(" + (chart.width / 2) + " ," +
                        (chart.height + chart.margin.top + 40) + ")")
                    .style("text-anchor", "middle")
                    .attr("font-size", "0.8em")
                    .text(chart.x1AxisDisplayName);

                div.append("g")
                    .attr("transform", "translate(0,1)")
                    .call(x2AxisLabel)
                    .style('display', function (d, i) {
                        return categories[i] == categories[0] ? "block " : "none"
                    })
                    // .style('fill', fontColor)
                    .selectAll('text') //addidng text on x-axis
                    // .style("font-size", axisLabelFontSize)
                    .style('text-anchor', 'start')
                    .attr('dx', '.55em')
                    .attr('transform', 'rotate(-50)');

                //adding axis labels
                div.append("g")
                    .attr("class", "y axis")
                    // .attr('class', 'y axis-grid')
                    .call(y1AxisLabel)


                div.append("text")
                    .attr("transform", "rotate(-90)")
                    .attr("y", 140)
                    .attr("dy", "-8em")
                    .style("text-anchor", "end")
                    .attr("font-size", "0.8em")

                div.append("g")
                    .append("text")
                    .attr("x", function (d, i) {
                        return categories[i] == categories[categories.length - 1] ? -12 : 5
                    })
                    .attr("y", function (d, i) {
                        return categories[i] == categories[categories.length - 1] ? ((chart.height / 2) + 108) : 157
                    })
                    .attr("dy", ".71em")
                    .attr("text-anchor", "start")
                    .attr("font-size", "0.8em")
                    .text(function (d) {
                        return d.key
                    });

                if (gridflag == true) {
                    // add the X gridlinese
                    div.append("g")
                        .attr("class", "grid")
                        .attr("transform", "translate(0," + chart.height + ")")
                        .call(make_x_gridlines(x1Scale)
                            .tickSize(-chart.height)
                            .tickFormat(""))

                    // add the Y gridlines
                    div.append("g")
                        .attr("class", "grid")
                        .call(make_y_gridlines(y1Scale)
                            .tickSize(-chart.width)
                            .tickFormat(""))
                }

                // Accessing nested data: https://groups.google.com/forum/#!topic/d3-js/kummm9mS4EA
                // data(function(d) {return d.values;})
                // this will dereference the values for nested data for each group
                div.selectAll(".barmpc")
                    .data(function (d) {
                        return d.values;
                    })
                    .enter()
                    .append("rect")
                    .attr("class", "barmpc")
                    .attr("x", function (d) {
                        return x1Scale(d.dim2_name);
                    })
                    .attr("width", x1Scale.bandwidth())
                    .attr("y", function (d) {
                        return y1Scale(d.metric1);
                    })
                    .attr("height", function (d) {
                        return chart.height - y1Scale(d.metric1);
                    })
                    .attr("fill", function (d) {
                        return metric1ColorScale(d.dim2_name)
                    })
                    .on('mouseover', function(d) {
                        tooltip.onMouseOver(d, this, function(d) {
                            return d.dim1_name + colonAnnotation + numberFormat(d.metric1);
                        });  // Pass the event for positioning
                    })
                    .on('mousemove', function(event) {
                        tooltip.onMouseMove(event);  // Use event for updating position
                    })
                    .on('mouseleave', function() {
                        tooltip.onMouseLeave();  // Hide tooltip on mouse leave
                    })
                    .on('contextmenu', function(d) {
                        console.log(d)
                        // Prepare clickedData with both axes' info
                        const clickedData = {
                            [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [d.dim1_name], // e.g., "metric1"
                            [chart.insightNavigator.realDataFieldNames.y1RealDataFieldName]:[d.dim2_name],
                        };
                        console.log("clickedData",clickedData);
                        // Generate the menu with current config and filters
                        const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                        // Show the context menu
                        contextMenu(menuItems).call(this, clickedData);

                        // Prevent default context menu
                        d3.event.preventDefault();
                    })
            });
        } else {
            x1Scale.domain(data.map((d) => {
                return d.dim2_name;
            }));
            x2Scale.domain(data.map((d) => {
                return d.dim2_name;
            }));
            y1Scale.domain([0, d3.max(data.map((d) => {
                return d.metric1
            }))]);

            var svg = d3.select(divId)
            svg.selectAll("*").remove();

            // Add an SVG element for each country, with the desired dimensions and margin.
            svg = d3.select(divId).selectAll("svg")
                .data(categories)
                .enter()
                .append("svg")
                .attr("width", chart.width + chart.margin.left + chart.margin.right)
                .attr("height", function (d, i) {
                    return categories[i] == categories[categories.length - 1] ?
                        chart.height + top1 + chart.margin.bottom : categories[i] == categories[0] ? chart.height + chart.margin.top + bottom1 : chart.height + top1 + bottom1
                })
                .append("g")
                .attr("transform", function (d, i) {
                    return categories[i] == categories[0] ?
                        "translate(" + chart.margin.left + "," + chart.margin.top + ")" : "translate(" + chart.margin.left + "," + top1 + ")"
                });


            // d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
            // var tip2 = d3.select(divId).append('div').attr('class', 'tooltip')
            //     .attr('style', 'position: absolute; opacity: 0;')

            const tooltip1 = createTooltip(divId);

            // Add <defs> and <clipPath> to the SVG
            svg.append("defs")
                .append("svg:clipPath")
                .attr("id", "clip1")  // Use d.key for the clipPath id
                .append("svg:rect")
                .attr("x", 0)
                .attr("y", -10)
                .attr("width", chart.width)   // Clip width matches chart width
                .attr("height", chart.height); // Clip height matches chart height

            // Append a group with clipPath applied
            const contentGroup = svg.append("g")
                .attr("class", "content")
                .attr("clip-path", "url(#clip1)");  // Dynamically set clip-path using d.key

            svg.append("g")
                .attr("class", "x-axis")
                .attr("transform", "translate(0," + chart.height + ")")

                .call(x1AxisLabel)
                .style('display', function (d, i) {
                    return categories[i] == categories[categories.length - 1] ? "block " : "none"
                })

                .selectAll('text')
                .style('text-anchor', 'end')
                .attr('dx', '-.1em')
                .attr('transform', 'rotate(-50)')

            //adding axis labels
            svg.append("text")
                .attr("transform", "translate(" + (chart.width / 2) + " ," +
                    (chart.height + chart.margin.top + 40) + ")")
                .style("text-anchor", "middle")
                .attr("font-size", ".8em")
                .text(chart.x1AxisDisplayName);

            svg.append("g")
                .attr("transform", "translate(0,1)")
                .attr("class","x2-axis")
                .call(x2AxisLabel)
                .style('display', function (d, i) {
                    return categories[i] == categories[0] ? "block " : "none"
                })
                .selectAll('text')
                .style('text-anchor', 'start')
                .attr('dx', '.55em')
                .attr('transform', 'rotate(-50)');

            svg.append("g")
                .attr("class", "y-axis")
                .call(y1AxisLabel)

            //adding axis labels
            svg.append("text")
                .attr("transform", "rotate(-90)")
                .attr("y", 10)
                .attr("dy", "-5.5em")
                .style("text-anchor", "end")
                .attr("font-size", fontSize)
                .text(chart.y1AxisDisplayName);

            //adding category name at right hand side
            svg.append("g")
                .append("text")
                .attr("x", function (d, i) {
                    return categories[i] == categories[categories.length - 1] ? -12 : 5
                })
                .attr("y", function (d, i) {
                    return categories[i] == categories[categories.length - 1] ? ((chart.height / 2) + 108) : 157
                })
                .attr("dy", ".71em")
                .attr("text-anchor", "start")
                .attr("font-size", "0.8em")
                .text(function (d) {
                    return d.key
                });

            if (gridflag === true) {
                // add the X gridlines
                svg.append("g")
                    .attr("class", "grid")
                    .attr("transform", "translate(0," + chart.height + ")")
                    .call(make_x_gridlines(x1Scale)
                        .tickSize(-chart.height)
                        .tickFormat(""))

                // add the Y gridlines
                svg.append("g")
                    .attr("class", "grid")
                    .call(make_y_gridlines(y1Scale)
                        .tickSize(-chart.width)
                        .tickFormat(""))
            }

            contentGroup.selectAll(".barmpc")
                .data(function (d) {
                    return d.values;
                })
                .enter()
                .append("rect")
                .attr("class", "barmpc")
                .attr("x", (d) => {
                    return x1Scale(d.dim2_name)
                })
                .attr("width", x1Scale.bandwidth())
                .attr("y", (d) => {
                    return y1Scale(d.metric1);
                })
                .attr("height", (d) => {
                    return chart.height - y1Scale(d.metric1);
                })
                .attr("fill", (d) => {
                    return metric1ColorScale(d.dim2_name)
                })
                .on('mouseover', function(d) {
                    tooltip1.onMouseOver(d, this, function(d) {
                        return d.dim1_name + colonAnnotation + numberFormat(d.metric1);
                    });  // Pass the event for positioning
                })
                .on('mousemove', function(event) {
                    tooltip1.onMouseMove(event);  // Use event for updating position
                })
                .on('mouseleave', function() {
                    tooltip1.onMouseLeave();  // Hide tooltip on mouse leave
                })
                .on('contextmenu', function(d) {
                    console.log(d)
                    // Prepare clickedData with both axes' info
                    const clickedData = {
                        [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [d.dim1_name], // e.g., "metric1"
                        [chart.insightNavigator.realDataFieldNames.y1RealDataFieldName]:[d.dim2_name],
                    };
                    console.log("clickedData",clickedData);
                    // Generate the menu with current config and filters
                    const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                    // Show the context menu
                    contextMenu(menuItems).call(this, clickedData);

                    // Prevent default context menu
                    d3.event.preventDefault();
                })

            // var zoomBehaviour = d3.zoom()
            //     .scaleExtent([0.5, 20])  // Define the zoom range (0.5x to 5x zoom)
            //     .on("zoom", ()=>{
            //         var zoomState = d3.event.transform;
            //         x1Scale.range([0, zoomState.k * chart.width]); // Stretch or shrink based on zoom level
            //         svg.select('.x-axis').call(d3.axisBottom(x1Scale));
            //         x2Scale.range([0, zoomState.k * chart.width]);
            //         svg.select('.x2-axis').call(d3.axisTop(x2Scale));
            //
            //         var newYscale = zoomState.rescaleY(y1Scale);
            //         svg.select(".y-axis").call(d3.axisLeft(newYscale) .tickSizeInner(-chart.width)
            //             .tickSizeOuter(-chart.width)
            //             .tickFormat(numberFormat)
            //             .ticks(4))
            //
            //         contentGroup.selectAll(".barmpc").attr("x", (d) => {
            //             return x1Scale(d.dim2_name)
            //         })
            //             .attr("width", x1Scale.bandwidth())
            //             // .attr("y", (d) => {
            //             //     return newYscale(d.metric1);
            //             // })
            //     });  // Attach the zoom event

            // Apply zoom to the SVG
            contentGroup.insert("rect","rect")
                .attr("width",chart.width)
                .attr("height",chart.height)
                .attr("fill","none")
                .attr("pointer-events","all")
                // .call(zoomBehaviour);



        }
    // });
}
